'use client'

import { createContext, useContext } from 'react'
import NewslettersPermissionsManager from '../utils/permissions/NewslettersPermissionsManager'
import TemplatesPermissionsManager from '../utils/permissions/TemplatesPermissionsManager'
import ContentPermissionsManager from '../utils/permissions/ContentPermissionsManager'

const PermissionsContext = createContext({
  pvfs: [] as string[],
  newsletter: new NewslettersPermissionsManager(),
  template: new TemplatesPermissionsManager(),
  campaign: new ContentPermissionsManager(),
})

type PermissionsProviderParams = {
  pvfs: string[]
  children: React.ReactNode
}

function PermissionsProvider({ pvfs, children }: PermissionsProviderParams) {
  const value = {
    pvfs,
    newsletter: new NewslettersPermissionsManager(pvfs),
    template: new TemplatesPermissionsManager(pvfs),
    campaign: new ContentPermissionsManager(pvfs),
  }

  return <PermissionsContext.Provider value={value}>{children}</PermissionsContext.Provider>
}

function usePermissionsContext() {
  return useContext(PermissionsContext)
}

export { PermissionsProvider, usePermissionsContext }
